import React, { useEffect, useState } from "react";
import CRScheduleDays from "../../CRScheduleDays";
import { useTranslation } from "react-i18next";
import { MDBBtn, MDBModalFooter } from "mdb-react-ui-kit";

function UserScheduleRouting({
  routingPlans,
  updatePlanValue,
  addDialPlans,
  setAddDialPlans,
  weeklyPlans,
  onClose,
  setSelectedValue,
}) {
  const [t, i18n] = useTranslation();
  const [sundayPlan, setSundayPlan] = useState(393);
  const [mondayPlan, setMondayPlan] = useState(393);
  const [tuesPlan, setTuesPlan] = useState(393);
  const [wedPlan, setWedPlan] = useState(393);
  const [thusPlan, setThusPlan] = useState(393);
  const [friPlan, setFriPlan] = useState(393);
  const [satPlan, setSatPlan] = useState(393);
  const [updatePlansDetails, setupdatePlansDetails] = useState([]);

  function updatePlansVal(dialid, redioOption, weekid) {
    const itemItex = addDialPlans.findIndex((item) => item.week_id === weekid);
    let updateDialPlan = [];

    const newPlan = {
      dial_planid: parseInt(dialid),
      week_id: parseInt(weekid),
    };
    if (itemItex === -1) {
      updateDialPlan = [...addDialPlans, newPlan];
      // setupdatePlansDetails(updateDialPlan);
      setAddDialPlans(updateDialPlan);
    } else {
      updateDialPlan = [...addDialPlans];
      updateDialPlan.splice(itemItex, 1, newPlan);
      // setupdatePlansDetails(updateDialPlan);
      setAddDialPlans(updateDialPlan);
    }
  }

  useEffect(() => {
    if (weeklyPlans.length > 0) {
      // debugger;
      // console.log("weeklyPlans ::::::::: "+JSON.stringify(weeklyPlans));
      weeklyPlans.map((item, index) => {
        switch (item.day) {
          case 1:
            setSundayPlan(item.plan_id);
            break;
          case 2:
            setMondayPlan(item.plan_id);
            break;
          case 3:
            setTuesPlan(item.plan_id);
            break;
          case 4:
            setWedPlan(item.plan_id);
            break;
          case 5:
            setThusPlan(item.plan_id);
            break;
          case 6:
            setFriPlan(item.plan_id);
            break;
          case 7:
            setSatPlan(item.plan_id);
            break;
        }
      });
    }
  }, [weeklyPlans]);

  const handleClick = async (e) => {
    e.preventDefault();
    //e.stopPropagation();
    updatePlanValue(null, "weekly", null);
    onClose();
  };
  return (
    <>
      <div className="d-flex align-items-start justify-content-center flex-column">
        <CRScheduleDays
          datelabel={t("monday")}
          routingPlans={routingPlans}
          activePlan={mondayPlan}
          updatePlanValue={updatePlansVal}
          dayIndex="2"
        />
        <CRScheduleDays
          datelabel={t("tuesday")}
          routingPlans={routingPlans}
          activePlan={tuesPlan}
          updatePlanValue={updatePlansVal}
          dayIndex="3"
        />
        <CRScheduleDays
          datelabel={t("wednesday")}
          routingPlans={routingPlans}
          activePlan={wedPlan}
          updatePlanValue={updatePlansVal}
          dayIndex="4"
        />
        <CRScheduleDays
          datelabel={t("thursday")}
          routingPlans={routingPlans}
          activePlan={thusPlan}
          updatePlanValue={updatePlansVal}
          dayIndex="5"
        />
        <CRScheduleDays
          datelabel={t("friday")}
          routingPlans={routingPlans}
          activePlan={friPlan}
          updatePlanValue={updatePlansVal}
          dayIndex="6"
        />
        <CRScheduleDays
          datelabel={t("saturday")}
          routingPlans={routingPlans}
          activePlan={satPlan}
          updatePlanValue={updatePlansVal}
          dayIndex="7"
        />
        <CRScheduleDays
          datelabel={t("sunday")}
          routingPlans={routingPlans}
          activePlan={sundayPlan}
          updatePlanValue={updatePlansVal}
          dayIndex="1"
        />
      </div>

      <MDBModalFooter>
        {addDialPlans && addDialPlans.length > 0 && (
          <>
            <MDBBtn
              color="secondary"
              onClick={(e) => {
                e.preventDefault();
                setSelectedValue(1);
                setAddDialPlans([]);
                onClose(e);
              }}
            >
              Cancel
            </MDBBtn>
            <MDBBtn onClick={(e) => handleClick(e)}>Ok</MDBBtn>
          </>
        )}
      </MDBModalFooter>
    </>
  );
}

export default UserScheduleRouting;
